module.exports = __webpack_public_path__ + "static/media/picture13.78c30c07.png";